// extracted by mini-css-extract-plugin
export var assigneeBadge = "_mo-0";
export var assigneeDetails = "_mo-1";
export var assigneeInfo = "_mo-2";
export var dropdownContainer = "_mo-4";
export var dropdownImage = "_mo-5";
export var editAssigneeInfo = "_mo-3";
export var editAssigneeModalContainer = "_mo-6";
export var hidden = "_mo-8";
export var input = "_mo-7";